<template>
    <div class="qualification-inquiry app-container">
        <el-button class="search-btn" :loading="doLoading" icon="el-icon-search" size="small" type="primary"
            @click="getList()">
            {{ $t('operation.button.search') }}
        </el-button>
        <el-table v-loading="doLoading" :data="list" border fit highlight-current-row style="width: 100%;">
            <!--    订单号No  -->
            <el-table-column :label="$t('order.no')" align="center" prop="orderNo" />
            <el-table-column :label="$t('po.quantity')" align="center" prop="status">
                <template>
                    <span>1</span>
                </template>
            </el-table-column>
            <!--     状态 -->
            <el-table-column :label="$t('Common.status')" align="center" prop="status">
                <template slot-scope="{row}">
                    <span>{{ $lt(initDict.paystate, row.status) }}</span>
                </template>
            </el-table-column>
        </el-table>
        <pagination v-show="total > 0" :limit.sync="listQuery.limit" :page.sync="listQuery.page" :total="total"
            @pagination="getList" />
    </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { kankunOrder } from '@/api/rus/api'
export default {
    name: 'QualificationInquiry',
    components: { Pagination },
    data() {
        return {
            doLoading: false,
            list: [],
            total: 0,
            listQuery: {
                page: 1,
                limit: 10
            },
            initDict: {
                paystate: 'sysaftersale.paystate',
            },
        }
    },
    methods: {
        getList() {
            this.doLoading = true
            kankunOrder({ ...this.listQuery }).then(res => {
                this.list = res.data.records
                this.total = +res.data.total
            }).catch(err => {
                console.error(err)
            }).finally(() => {
                this.doLoading = false
            })
        },

    }
}


</script>

<style lang="scss" scoped>
.qualification-inquiry {
    text-align: left;

    .search-btn {
        margin: 10px 0 10px 0;
    }
}
</style>